import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Form, InputNumber, Spin, Select, Upload, Input, Tabs, Space } from 'antd';
import { CheckCircleOutlined, HomeOutlined, CloseCircleOutlined, UploadOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import PopupFrame from '../../component/popupFrame/popupFrame';//删除弹框
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import Message from '../../component/message/message';
import './eplatformResourcePageManagement.css';
import tag1 from '../../public/img/tag/tag1.png';

const { TabPane } = Tabs;
const { Option } = Select;
const ClassicEditor = window.ClassicEditor;

const EplatformResourcePageManagement = (props) => {

    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isAudit, setIsAudit] = useState(false);
    const [auditModel, setAuditModel] = useState({});
    const [tabIndex, setTabIndex] = useState("1");
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [flag, setFlag] = useState("");
    const [paramModel, setParamModel] = useState({});
    const [deleteTipText, setDeleteTipText] = useState("");
    const [downloadModel, setDownloadModel] = useState("");
    const [resourceModel, setResourceModel] = useState({});
    const [ckeditor, setCkeditor] = useState(null);
    const [editor, setEditor] = useState(null);
    const [uploadFileList, setUploadFileList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [fileSize, setFileSize] = useState('');

    const [documentFileList, setDocumentFileList] = useState([]);
    const tableColumns = {
    }


    useEffect(() => {
        searchFileSize();
        search(pageSize, 1, "N");
        ClassicEditor.create(document.querySelector('#editor'), Config.ckEditorConfig)
        .then(editor => {
            setCkeditor(editor);
        }).catch(error => { console.log(error) });

        ClassicEditor.create(document.querySelector('#displayContent'), Config.ckEditorConfig)
        .then(editor => {
            const editorContainer = document.querySelector('.ck-editor__editable'); 
            editor.enableReadOnlyMode( 'my-feature-id' );
            editor.ui.view.toolbar.element.style.display = 'none'; // 隐藏工具栏
            editorContainer.style.border = 'none'; // 隐藏边框
            editorContainer.style.backgroundColor = '#f8f7f3'; // 设置背景色
            setEditor(editor)
        }).catch(error => { console.log(error) });
    }, []);

    const searchFileSize = () => {
        let model = {
            "segment": 'SYSTEM_CONFIG',
            "code": 'FILE_SIZE',
        }
        Base.callBackApi("commonDropDown/searchSysParamByCode", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                const sizeNumber = parseInt(data.object?.parmValue1 ?? '');
                const size = isNaN(sizeNumber) ? 10 : sizeNumber;
                setFileSize(size);
            } else {
                errFrameShow('error', data.msg);
            }
        }).catch(err => { });
    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else if ("reset" === flag) {
            model = {}
        } else {
            model = searchModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;

        setIsLoad(true);
        setSpinInfo("Searching...");
        Base.callBackApi("resource/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", "No record is founed.");
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        messageShowHandler();
        if (key) {
            if (key === "2") {
                if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({ status: "Y", recipient: 'GENERAL' });
        setDocumentFileList([]);
        ckeditor.setData('');
        ckeditor.destroy();
        ClassicEditor.create(document.querySelector('#editor'), Config.ckEditorConfig)
            .then(editor => {

                setCkeditor(editor);
            }).catch(error => { console.log(error) });
        setFlag("add");
        setTabIndex("2");
    }

    const initForm = (model = {}) => {
        form.resetFields();
        let recipientList;
        if (model.recipient) {
            recipientList = model.recipient.split(',');
            recipientList = recipientList.map(item => item.trim());
        }
        form.setFieldsValue({
            resourcePageCode: model.resourcePageCode ?? '',
            resourcePageName: model.resourcePageName ?? '',
            resourcePageDescription: model.resourcePageDescription ?? '',
            recipient: recipientList ?? '',
            displayContent: model.display_content ?? '',
            status: model.status ?? '',
            dispSeq: model.dispSeq ?? '',
        });
    }


    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo("Data is processing...");
        let deleteModel = resourceModel;
        deleteModel.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("resource/delete", deleteModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                cancel();
                search(pageSize, current, "Y", false);
                errFrameShow("success", "Deleted successfully.");
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const downloadFile = (item) => {
        if (!Base.stopClick()){
            return;
        }
        Base.downloadFile(item.url + '?' + Config.sasToken, item.name)
        // if (item.lastModified || isLoad) {
        //     return;
        // }
        // setIsLoad(true);
        // item.code = "RESOURCE_PATH";
        // fetch(Config.apiDownloadServer + "downloadFile/downloadFile", {
        //     method: 'POST',
        //     body: JSON.stringify(item),
        //     headers: Config.header,
        //     mode: 'cors',
        //     cache: 'default'
        // }).then(res => res.blob()).then(blob => {
        //     if (blob.type == "application/json") {
        //         var reader = new FileReader();
        //         reader.onload = e => {
        //             var data = JSON.parse(e.target.result);
        //             errFrameShow.error(data.msg);
        //         }
        //         reader.readAsText(blob);
        //     } else {
        //         if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
        //             window.navigator.msSaveOrOpenBlob(blob, item.name);
        //         } else {// for Non-IE (chrome, firefox etc.)
        //             var a = document.createElement('a');
        //             document.body.appendChild(a);
        //             a.style = 'display: none';
        //             var url = window.URL.createObjectURL(blob);
        //             a.href = url;
        //             a.download = item.name;
        //             a.click();
        //             a.remove();
        //             window.URL.revokeObjectURL(url);
        //         }
        //     }
        // }).catch(err => ({ err })).finally(() => {
        //     setIsLoad(false)
        // });
    }

    const onSave = (values) => {
        messageShowHandler();
        setIsLoad(true);
        setSpinInfo("Data is processing...")
        let formData = new FormData();
        let url = "";
        if (flag === "add") {
            url = "resource/insert";
        } else if (flag === 'edit') {
            url = "resource/update"
            values.resourceId = resourceModel.resourceId;
            values.lastUpdatedDate = resourceModel.lastUpdatedDate;
        }
        values.menuFuncId = Config.funcInfo.funcId;
        let content = ckeditor.getData()?.replace(/<a/g, '<a target="_blank"');
        // 处理图片
        if(content) {
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = content;
            var images = tempDiv.getElementsByTagName('img');
            for (var i = 0; i < images.length; i++) {
                var img = images[i];
                var src = img.getAttribute('src');
                var index = src.indexOf('?sv=');
                if (index !== -1) {
                    var newSrc = src.substring(0, index);
                    img.setAttribute('src', newSrc);
                }
            }
            values.displayContent = tempDiv.innerHTML;
        }
        // 修改文件，区分新上传和旧文件
        let oldFiles = [];
        for (let file of documentFileList) {
            if (file.status != undefined && file.status != 'old') {
                formData.append('files', file.originFileObj);
            } else {
                oldFiles.push(file.uid);
            }
        }
        values.pastList = oldFiles;
        values.attachment = null;
        values.recipientList = values.recipient;
        formData.append("model", JSON.stringify(values));
        Base.callBackUploadApi(url, formData).then((data) => {
            if ("SUCCESS" === data.msg) {
                searchById(data.object)
                errFrameShow("success", "Saved successfully.");
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false);
        });
    }

    const searchById = (model) => {
        setIsLoading(true);
        Base.callBackApi("resource/searchById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let resourceModel = data.object;
                initForm(resourceModel);
                setResourceModel(resourceModel)
                setFlag("edit");
                setDocumentFileList(resourceModel?.resourceAnnexModelList?.map(item => {
                    return {
                        uid: item.resourceAnnexId,
                        name: item.annexName,
                        path: item.storagePath,
                        url: Config.resourceFiles + item.storagePath,
                        status: 'old'
                    }
                }));

                // 处理图片
                let content;
                if(resourceModel.displayContent) {
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = resourceModel.displayContent;
                    var images = tempDiv.getElementsByTagName('img');
                    for (var i = 0; i < images.length; i++) {
                        var img = images[i];
                        var src = img.getAttribute('src');
                        var index = src.indexOf(Config.imgServer);
                        if (index !== -1) {
                            var newSrc = src + '?' + Config.sasToken;
                            img.setAttribute('src', newSrc);
                        }
                    }
                    content = tempDiv.innerHTML;
                }
                ckeditor.setData(content);
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoading(false));
    }

    const searchDetailById = (model) => {
        setIsLoading(true);
        Base.callBackApi("resource/searchById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let resourceModel = data.object;
                initForm(resourceModel);
                setResourceModel(resourceModel)
                setFlag("detail");
                setDocumentFileList(resourceModel?.resourceAnnexModelList?.map(item => {
                    return {
                        uid: item.resourceAnnexId,
                        name: item.annexName,
                        path: item.storagePath,
                        url: Config.resourceFiles + item.storagePath,
                        status: 'old'
                    }
                }));
                let displayContent = resourceModel?.displayContent?.replace(/\\/g, "/")?.replace(/&nbsp;/g, ' ');
                // 处理图片
                if(displayContent) {
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = displayContent;
                    var images = tempDiv.getElementsByTagName('img');
                    for (var i = 0; i < images.length; i++) {
                        var img = images[i];
                        var src = img.getAttribute('src');
                        var index = src.indexOf(Config.imgServer);
                        if (index !== -1) {
                            var newSrc = src + '?' + Config.sasToken;
                            img.setAttribute('src', newSrc);
                        }
                    }
                    displayContent = tempDiv.innerHTML;
                }
                editor.setData(displayContent);
                // $("#displayContent").empty().append(content);
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoading(false));
    }


    const cancel = () => {
        messageShowHandler();
        setFlag("");
        ckeditor.setData('');
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const update = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setFlag("edit");
        searchById(model.resourceId)
        setTabIndex("2");
    }

    const detail = (model, e) => {
        e.stopPropagation();
        initForm(model)
        setFlag("detail");
        searchDetailById(model.resourceId)
        setTabIndex("2");
    }


    const deleteOne = (model, e) => {
        e.stopPropagation();
        setResourceModel(model)
        setIsDeleteFrame(true);
        setDeleteTipText("Resource" + ":" + model.resourcePageCode + "")
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const deleteFile = (index) => {
        let newList = JSON.parse(JSON.stringify(documentFileList));
        newList.splice(index, 1);
        setDocumentFileList(newList);
    }

    // 附件上传部分
    const handleDocumentChange = (file) => {
        let newFileList = file.fileList;
        file = file.file;
        if (file.status === "uploading") {
            const maxSize = fileSize * 1024 * 1024; // 25MB
            // 检查文件大小
            if (file.size > maxSize) {
                errFrameShow('error', 'File size must be less than ' + fileSize + 'MB.');
                return;
            }
            setDocumentFileList(newFileList);
            return
        } else if (file.status === "error") {
            errFrameShow('error', file.error.message);
        } else if (file?.response?.error) {
            errFrameShow('error', file.response.error?.message);
        }
        setDocumentFileList(newFileList.filter(item => (item.status === 'done' && !item.response.error) || item.status === 'old'));
    }

    const columns = [
        {
            title: "Resource Page Code",
            dataIndex: 'resourcePageCode',
            className: 'tableWidth31',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'ePlatformResourcePageId') },
        },
        {
            title: "Resource Page Name",
            dataIndex: 'resourcePageName',
            className: 'tableWidth31',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'ePlatformResourcePageName') },
        },
        {
            title: "Recipient",
            dataIndex: 'recipient',
            className: 'tableWidth22',
            render: (text) => {
                let recipientList;
                if (text) {
                    recipientList = text.split(',');
                    recipientList = recipientList.map(item => {
                        const mappedItem = context.recipientMap.find(mapItem => mapItem.value === item.trim());
                        return mappedItem ? mappedItem.label : item.trim();
                    });
                }
                return recipientList.join(', ');
            },
        },
        {
            title: "Status",
            dataIndex: 'status',
            className: 'tableWidth9',
            render: (text) => ContextHandler.getMapValue('activeStatusMap', text),
            sorter: (a, b) => { return Base.sortMethod(a, b, 'status') },
        },
        {
            title: "Seq",
            dataIndex: 'dispSeq',
            className: 'tableWidth8',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'dispSeq') },
        },
        {
            title: "Operation",
            dataIndex: '',
            fixed: 'right',
            width: 275,
            className: ' sysControls',
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> Edit</div>
                <div className='sysView' onClick={(e) => detail(record, e)} ><SearchOutlined /> View</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e)} hidden={Config.funcInfo.canDelete === "N"}><DeleteOutlined /> Delete</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> Log</div>
            </div>
        },
    ];

    return (
        <div id="container" className="template eplatformResourcePageManagement">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab="List">
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle">Resource Page Code</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder="Resource Page Code" value={searchModel.resourcePageCode}
                                            onChange={(e) => searchChange('resourcePageCode', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Resource Page Name</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" placeholder="Resource Page Name" value={searchModel.resourcePageName}
                                            onChange={(e) => searchChange('resourcePageName', e.target.value)}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Recipient</div>
                                    <div className="sysSerchInput">
                                        <Select className='sysSelect'
                                            value={searchModel.recipient || ''}
                                            onChange={(value) => searchChange('recipient', value)}>
                                            <Option value=''></Option>
                                            {context.recipientMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                        </Select>
                                    </div>
                                </div>
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>Search</Button>
                                    <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>Reset</Button>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="buttonRelative">
                                <Button className='sysBtn btnBlue' type="primary" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>Add</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    rowKey="resourceId"
                                    scroll={{ x: 1400 }}
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChange,            //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                                        total: tablesCount,             //总共多少条数据
                                        current: current,         //当前页
                                        pageSize: pageSize,       //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane tab={"Resources"} key="2" forceRender={true}>
                            <Form form={form} onFinish={onSave}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">Resource Page Code</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="resourcePageCode"
                                                rules={[
                                                    { required: true, message: 'Resource Page Code is required.' },
                                                ]}
                                                getValueFromEvent={(e) => Base.codeChange(e, 50)}
                                            >
                                                <Input type="text" placeholder="Resource Page Code" maxLength={50} disabled={flag == "edit" || flag === 'detail'} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">Seq</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="dispSeq"
                                                rules={[
                                                    { required: true, validator: (rule, value) => Base.checkNbrOrNull(value, null, 999999999) },
                                                ]}
                                            >
                                                <InputNumber className='sysInputNumber'
                                                    placeholder='Seq'
                                                    precision={0} maxLength={9}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">Resource Page Name</div>
                                        <div className="sysInputMax">
                                            <Form.Item
                                                name="resourcePageName"
                                                rules={[
                                                    { required: true, message: 'Resource Page Name is required.' },
                                                ]}
                                            >
                                                <Input type="text" placeholder="Resource Page Name" maxLength={150} disabled={flag === 'detail'} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>

                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">Resource Page Description</div>
                                        <div className="sysInputMax">
                                            <Form.Item
                                                name="resourcePageDescription"
                                            >
                                                <Input type="text" placeholder="Resource Page Description" maxLength={500} disabled={flag === 'detail'} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">Recipient</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="recipient"
                                                rules={[
                                                    { required: true, message: 'Recipient is required.' },
                                                ]}
                                            >
                                                <Select className="sysSelect"
                                                    mode="multiple"
                                                    allowClear
                                                    disabled={flag === 'detail'}
                                                >
                                                    {context.recipientMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">Status</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="status"
                                                rules={[
                                                    { required: true, message: 'Status is required.' },
                                                ]}
                                            >
                                                <Select className='sysSelect' disabled={flag === 'detail'}>
                                                    <Option value=''></Option>
                                                    {context.activeStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">Website Display Content</div>


                                        <div className="sysInputs editor" hidden={flag == 'detail'}>
                                            <div id="editor" className="editor" ></div>
                                        </div>
                                        <div className='sysInputMax' hidden={flag == 'add' || flag == 'edit'}>
                                            <div id="displayContent" className='displayContent' ></div>
                                        </div>

                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">Attachment</div>
                                        <div className='sysInput' >
                                            <Form.Item
                                                name="attachment"
                                            >
                                                <Upload
                                                    action={Config.uploadTestServer}
                                                    key={"1"}
                                                    accept=".pdf,.ppt,.pptx,.doc,.docx,.xls,.xlsx,.jpeg,.jpg,.png,.bmp,.tiff,.mp3,.wav,.txt"
                                                    fileList={documentFileList}
                                                    onChange={(file) => handleDocumentChange(file)}
                                                    showUploadList={false}>
                                                    <Button icon={<UploadOutlined />} disabled={flag == 'detail'} className='uploadButton' onClick={() => messageShowHandler()}>Select File</Button>
                                                </Upload>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>

                                {documentFileList.length !== 0 &&
                                    <div className='uploadFile' style={{ marginTop: '-5px' }}>
                                        {documentFileList.map((item, index) =>
                                            <div className='upload' key={index} title={item.name} style={{ display: 'flex' }}>
                                                <div className="uploadFileRow" >
                                                    <img src={tag1} className="tagImg"></img>
                                                    <div onClick={() => downloadFile(item)} className='fileBox' >{item.name}</div>
                                                    {flag != 'detail' && <DeleteOutlined className='deleteFileButton' style={{ marginLeft: '4px' }} title='Delete File' onClick={() => deleteFile(index)} />}
                                                </div>
                                            </div>
                                        )
                                        }

                                    </div>
                                }
                                <div className="sysSaveButton" hidden={flag == 'detail'}>
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} htmlType="submit" icon={<CheckCircleOutlined />}>Save</Button>
                                    <Button className="sysBtn" onClick={cancel} icon={<CloseCircleOutlined />}>Cancel</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
        </div>
    )

}

export default EplatformResourcePageManagement;